
import React, { Component } from 'react';
import { Modal, Button, Divider, Table, Tag, Row, Col, Tabs, Tooltip } from 'antd';

import ImageView from '../../ui/ImageView';
import Image from '../../ui/Image';

//引入样式
import './applicationStyle.css';

const dealField = [{
    "text": "业务类型",
    "field": "tradeVehicleType",
}, {
    "text": "服务费用",
    "field": "commission",
}, {
    "text": "过户类型",
    "field": "transferType",
}, {
    "text": "车辆转入地",
    "field": "destination",
}, {
    "text": "车价合计",
    "field": "amount",
}, {
    "text": "是否代办",
    "field": "agent",
}, {
    "text": "代理公司",
    "field": "agencyName",
}, {
    "text": "代理人员",
    "field": "agentManName",
}, {
    "text": "代理人电话",
    "field": "agentTel",
}, {
    "text": "备注",
    "field": "remark",
}];

const vehicleField = [{
    "text": "登记证书编号",
    "field": "vehicle.registerNo",
}, {
    "text": "车架号",
    "field": "vehicle.vin",
}, {
    "text": "车牌号码",
    "field": "vehicle.plateNo",
}, {
    "text": "厂牌型号",
    "field": "vehicle.brandModel",
}, {
    "text": "车辆品牌",
    "field": "vehicle.brand",
}, {
    "text": "车辆型号",
    "field": "vehicle.model",
}, {
    "text": "发动机型号",
    "field": "vehicle.engineModel",
}, {
    "text": "发动机号",
    "field": "vehicle.engineNo",
}, {
    "text": "出厂日期",
    "field": "vehicle.productionDate",
}, {
    "text": "车辆类型",
    "field": "vehicle.vehicleType",
}, {
    "text": "燃油种类",
    "field": "vehicle.fuelType",
}, {
    "text": "使用性质",
    "field": "vehicle.useProperty",
}, {
    "text": "是否进口车",
    "field": "vehicle.isImported",
}, {
    "text": "排放标准",
    "field": "vehicle.emissionStandard",
}, {
    "text": "号牌种类",
    "field": "vehicle.plateType",
}, {
    "text": "新车牌号",
    "field": "vehicle.newPlateNo",
}];


const buyer = [{
    "text": "证件类型",
    "field": "buyer.creditType",
}, {
    "text": "证件编号",
    "field": "buyer.creditNo",
}, {
    "text": "买方姓名",
    "field": "buyer.name",
}, {
    "text": "联系电话",
    "field": "buyer.tel",
}, {
    "text": "居住地址",
    "field": "buyer.residenceAddress",
}];

const seller = [{
    "text": "证件类型",
    "field": "seller.creditType",
}, {
    "text": "证件编号",
    "field": "seller.creditNo",
}, {
    "text": "卖方姓名",
    "field": "seller.name",
}, {
    "text": "联系电话",
    "field": "seller.tel"
}, {
    "text": "居住地址",
    "field": "seller.residenceAddress",
}];

const ticketColumns = [
    {
        title: '开票时间',
        dataIndex: 'billingTime',
        width: '20%',
    }, {
        title: '发票号码',
        dataIndex: 'invoiceNo',
        width: '15%',
    }, {
        title: '车价合计',
        dataIndex: 'amount',
        width: '20%',
    }, {
        title: '开票人',
        dataIndex: 'drawer',
        width: '10%',
    }, {
        title: '票据状态',
        dataIndex: 'state',
        width: '10%',
        render: (text) => text === 1 ?
            (<Tag color="#108ee9">已开票</Tag>)
            : text === 2 ?
                (<Tag color="#ff5500">已作废</Tag>)
                : text === 3 ?
                    (<Tag color="#ff5500">自带票</Tag>)
                    :
                    (<Tag>未开票</Tag>)
    }, {
        title: '备注',
        dataIndex: 'remark',
        width: '30%',
        render: (text, record, index) => (
            <Tooltip title={text}>
                <span>{text}</span>
            </Tooltip>
        )
    }];


const tradeImage = [{
    text: '行驶证',
    field: 'vehicleLicense'
}, {
    text: '机动车登记证首页',
    field: 'vehicleRegister'
}, {
    text: '机动车登记证尾页',
    field: 'vehicleRegister_1'
}, {
    text: '买家身份证（人像）',
    field: 'buyerCreditFront'
}, {
    text: '买家身份证（国徽）',
    field: 'buyerCreditBack'
}, {
    text: '卖家身份证（人像）',
    field: 'sellerCreditFront'
}, {
    text: '卖家身份证（国徽）',
    field: 'sellerCreditBack'
}]

const checkImage = [{
    text: '左前方斜视45度',
    field: 'leftFront'
}, {
    text: '右后方斜视45度',
    field: 'rightBack'
}, {
    text: '车辆识别代号',
    field: 'vinPhoto'
}, {
    text: '三角警示牌',
    field: 'warningTriangle'
}, {
    text: '前排主副驾安全带',
    field: 'frontRow'
}, {
    text: '发动机',
    field: 'engine'
}, {
    text: '机动车标准照',
    field: 'standard'
}, {
    text: '车架号拓印膜',
    field: 'vinRubbing'
}, {
    text: '其他照片1',
    field: 'checkMore_1'
}, {
    text: '其他照片2',
    field: 'checkMore_2'
}]
class ApplicationPrint extends Component {

    state = {
        image: null,
        previewVisible: false,
        previewImage: null,
        activeKey: 'deal',
    }


    creaateDetailTable = (data) => {
        const { detailData } = this.props;
        let dom = [];
        let tdNum = 3;
        for (let i = 0; i < data.length; i += tdNum) {
            let td = [];
            for (let j = 0; j < tdNum && (i + j) < data.length; j++) {
                let text = (<td key={"td" + i + j}>{data[i + j]["text"] + "："}</td>);
                let colSpan = 1;
                if ((i + j) === (data.length - 1)) {
                    colSpan = (tdNum - j) * 2 - 1;
                }
                let field = (<td key={"td" + i + j + 1} colSpan={colSpan}>{detailData[data[i + j]["field"]]}</td>);
                td.push(text);
                td.push(field);
            }
            let tr = (<tr key={"tr" + i}>{td}</tr>);
            dom.push(tr);
        }
        let table = (
            <table className="application-detail-table">
                <tbody>
                    {dom}
                </tbody>
            </table>
        );
        return table;
    }

    // 图片列表
    createImageDom = (field) => {
        let dom = [];
        const { detailData } = this.props;
        const imgsInfo = detailData.image;
        for (let i = 0; i < field.length; i += 1) {
            let path = imgsInfo != null && imgsInfo[field[i]["field"]] ? "data:image/jpeg;base64," + imgsInfo[field[i]["field"]] : "";
            let imgurl = detailData.imageUrl && detailData.imageUrl[field[i]["field"]] ? detailData.imageUrl[field[i]["field"]] : "";
            let img = (
                <Col span={3} key={i} style={{ margin: '5px 0'}}>
                    <Image
                        original={true}
                        onlyView={true}
                        file={path}
                        text={field[i].text}
                        url={imgurl}
                    />
                </Col>
            );
            dom.push(img);
        }
        return (<Row>{dom}</Row>);
    }

    // 其他图片
    otherImgList = () => {
        let dom = [];
        const { detailData } = this.props;
        if(detailData != null &&　detailData.otherImages != null && detailData.otherImages.length > 0){
            let otherImagesUrl = detailData.otherImagesUrl;
            detailData.otherImages.forEach((item, index) => {
                let image = "data:image/jpeg;base64," + item
                let img = (
                    <Col span={3} key={index}>
                        <Image
                            original={true}
                            onlyView={true}
                            file={image}
                            url={otherImagesUrl[index]}
                        />
                    </Col>
                );
                dom.push(img);
            })
        }
        return <Row>{dom}</Row>

    }

    render() {
        const { visible, onCancel, detailData } = this.props;
        return (
            <Modal
                width={1200}
                visible={visible}
                title="申请单详情"
                okText="确定"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.print}
                zIndex={1000}
                footer={[
                    <Button key="take" type="primary" onClick={onCancel}>确定</Button>,
                ]}
                afterClose={() => {
                    this.setState({ activeKey: 'deal' })
                }}
            >
                <div>
                    <Tabs tabPosition='left' activeKey={this.state.activeKey}
                        onChange={(activeKey) => {
                            this.setState({ activeKey: activeKey });
                        }}
                    >
                        <Tabs.TabPane tab="交易信息" key="deal">
                            <Divider orientation="left" style={{ marginTop: 0 }}>交易信息</Divider>
                            {this.creaateDetailTable(dealField)}

                            <Divider orientation="left">车辆信息</Divider>
                            {this.creaateDetailTable(vehicleField)}

                            <Divider orientation="left">买方信息</Divider>
                            {this.creaateDetailTable(buyer)}
                            <Divider orientation="left">卖方信息</Divider>
                            {this.creaateDetailTable(seller)}

                        </Tabs.TabPane>

                        <Tabs.TabPane tab="相关图片" key="image">
                            <Divider orientation="left">过户照片</Divider>
                            {this.createImageDom(tradeImage)}
                            <Divider orientation="left">查验照片</Divider>
                            {this.createImageDom(checkImage)}
                            <Divider orientation="left">其他照片</Divider>
                            {this.otherImgList()}
                        </Tabs.TabPane>

                        <Tabs.TabPane tab="开票记录" key="bill">
                            <Table rowKey="id"
                                columns={ticketColumns}
                                dataSource={detailData["ticket"] == null ? [] : detailData["ticket"]}
                                pagination={false}
                                style={{ border: '1px solid #e8e8e8', borderBottom: 0 }}
                            />
                        </Tabs.TabPane>
                    </Tabs>

                </div>
                <ImageView src={this.state.previewImage} visible={this.state.previewVisible} handleCancel={this.handleCancel} />
            </Modal>
        );
    }
}


export default ApplicationPrint;